import { AnyAction, Dispatch } from 'redux'
import { StatusCodes } from 'http-status-codes'
import fetchRecruiterInfo from '../../service/user/fetch-recruiter-info/fetchRecruiterInfo'
import { setUserInfo } from '../../state/actions/user/user'
import { unexpectedError, unexpectedResponse, unauthorizedError } from '../../util/show-error-dialog/showErrorDialog'

type props = {
  dispatch: Dispatch<AnyAction>,
  hideDialog?: boolean,
}

const fetchAndSetRecruiterInfo = async ({ dispatch, hideDialog }: props) => {
  try {
    const response = await fetchRecruiterInfo()
    if (response.status === StatusCodes.OK && response.data) {
      const recruiterInfo = response.data
      dispatch(setUserInfo(recruiterInfo))
      return true
    }
    dispatch(unexpectedResponse())
  } catch (error) {
    if (hideDialog) {
      return false
    }

    if (error.response?.status === StatusCodes.UNAUTHORIZED) {
      dispatch(unauthorizedError(dispatch))
    } else {
      dispatch(unexpectedError())
    }
  }
  return false
}

export default fetchAndSetRecruiterInfo
